<template>
  <div class="section mt-1">
    <div class="tab-container-1">
      <nav class="pill-tabs" aria-label="Member Categories">
        <button
          class="pill-tab"
          :class="{ active: wing == 1 }"
          @click="getMembersList(1)"
          type="button"
        >
          {{ $t("wisdom") }} {{ unit.wisdom_count }}
        </button>
        <button
          class="pill-tab"
          :class="{ active: wing == 2 }"
          @click="getMembersList(2)"
          type="button"
        >
          {{ $t("youth") }} {{ unit.youth_count }}
        </button>
        <button
          class="pill-tab"
          :class="{ active: wing == 3 }"
          @click="getMembersList(3)"
          type="button"
        >
          {{ $t("students") }} {{ unit.students_count }}
        </button>
        <button
          class="pill-tab"
          :class="{ active: wing == 4 }"
          @click="getMembersList(4)"
          type="button"
        >
          {{ $t("women") }} {{ unit.women_count }}
        </button>
        <button
          class="pill-tab"
          :class="{ active: wing == 5 }"
          @click="getMembersList(5)"
          type="button"
        >
          {{ $t("balavedi") }} {{ unit.balavedi_count }}
        </button>
        <button
          class="pill-tab"
          :class="{ active: wing == 6 }"
          @click="getMembersList(6)"
          type="button"
        >
          {{ $t("girls") }} {{ unit.girls_count }}
        </button>
      </nav>
    </div>
  </div>
  <!-- AddMemberModel -->
  <div
    class="modal fade action-sheet"
    id="addMemberModel"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t("member_details") }}</h5>
        </div>
        <div class="modal-body">
          <div class="action-sheet-content">
            <Form @submit="addMember" :validation-schema="schema">
              <div class="form-group basic">
                <label class="label" for="Name">{{ $t("name") }} </label>
                <Field
                  name="name"
                  type="text"
                  class="form-control"
                  id="name"
                  v-model="name"
                  :placeholder="$t('enter_name')"
                  autocomplete="off"
                />
                <ErrorMessage name="name" class="error-feedback" />
              </div>
              <div class="form-group basic">
                <label class="label" for="age">{{ $t("age") }}</label>
                <Field
                  name="age"
                  type="number"
                  class="form-control"
                  id="age"
                  v-model="age"
                  :placeholder="$t('enter_age')"
                  autocomplete="off"
                />
                <ErrorMessage name="age" class="error-feedback" />
              </div>
              <div class="form-group basic">
                <div class="input-wrapper">
                  <label class="label text-primary" for="job">
                    {{ $t("job") }}
                  </label>
                  <Field
                    :disabled="disable_all"
                    name="job"
                    as="select"
                    class="form-control"
                    v-model="formData.job"
                  >
                    <option value="">{{ $t("select_profession") }}</option>
                    <option
                      v-for="item in profession_list"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ $i18n.locale === "en" ? item.name : item.name_mal }}
                    </option>
                  </Field>
                  <ErrorMessage name="job" class="error-feedback" />
                </div>
              </div>
              <div class="form-group" v-if="message">
                <div v-if="message" class="error-feedback">
                  {{ message }}
                </div>
              </div>
              <div class="form-group basic">
                <div class="input-wrapper row">
                  <label class="label" for="country_code">{{
                    $t("mobile_number")
                  }}</label>
                  <div class="form-group" style="width: 30% !important">
                    <div class="input-wrapper">
                      <Field
                        as="select"
                        class="form-control custom-select"
                        v-model="country_code"
                        name="country_code"
                        id="select4"
                        @change="onChangeCountryCode($event)"
                      >
                        <option
                          v-for="item in country_code_list"
                          :value="item.item_value"
                          v-bind:key="item.item_value"
                        >
                          {{ item.name }}
                        </option>
                      </Field>
                    </div>
                  </div>
                  <div
                    class="form-group mobile-field"
                    style="width: 68% !important; margin-left: 2%"
                  >
                    <div class="input-wrapper">
                      <Field
                        name="mobile_number"
                        type="number"
                        id="mobile_number"
                        class="form-control"
                        placeholder=""
                        autocomplete="off"
                        v-model="mobile_number"
                        oninput="javascript: this.value.replace(/[\s\/]/g,''); if(this.value.charAt(0) == 0){ this.value = this.value.slice(1, 11); } if(this.value.length > 10) { this.value = this.value.slice(0, 10);} "
                      />
                    </div>
                  </div>
                  <ErrorMessage name="mobile_number" class="error-feedback" />
                </div>
              </div>
              <div class="form-group basic">
                <div class="input-wrapper row">
                  <label class="label" for="country_code">{{
                    $t("whatsapp_number")
                  }}</label>
                  <div class="form-group" style="width: 30% !important">
                    <div class="input-wrapper">
                      <Field
                        as="select"
                        class="form-control custom-select"
                        v-model="country_code_whatsapp"
                        name="country_code_whatsapp"
                        id="select4"
                      >
                        <option
                          v-for="item in country_code_list"
                          :value="item.item_value"
                          v-bind:key="item.item_value"
                        >
                          {{ item.name }}
                        </option>
                      </Field>
                    </div>
                  </div>
                  <div
                    class="form-group mobile-field"
                    style="width: 68% !important; margin-left: 2%"
                  >
                    <div class="input-wrapper">
                      <Field
                        name="whatsapp_number"
                        type="number"
                        id="whatsapp_number"
                        class="form-control"
                        placeholder=""
                        autocomplete="off"
                        v-model="whatsapp_number"
                        oninput="javascript: this.value.replace(/[\s\/]/g,''); if(this.value.charAt(0) == 0){ this.value = this.value.slice(1, 11); } if(this.value.length > 10) { this.value = this.value.slice(0, 10);} "
                      />
                    </div>
                  </div>
                  <ErrorMessage name="whatsapp_number" class="error-feedback" />
                </div>
              </div>
              <!-- <div class="form-group basic">
                                <label class="label" for="stay">Stay <span class="mal-text">(താമസം)</span></label>
                                <div class="form-group boxed">
                                    <div class="input-wrapper mal-text">
                                        <Field as="select" class="form-control custom-select" v-model="stay" name="stay"
                                            id="select4">
                                            <option value>താമസം സെലക്ട് ചെയ്യുക</option>
                                            <option value="native">നാട്ടിൽ</option>
                                            <option value="outof_state">കേരളത്തിന് പുറത്ത്</option>
                                            <option value="outof_country">ഇന്ത്യക്കു പുറത്ത്</option>

                                        </Field>
                                    </div>
                                </div>
                                <ErrorMessage name="stay" class="error-feedback" />
                            </div>   -->
              <div class="form-group basic">
                <label class="label" for="wing">{{ $t("wing") }}</label>
                <div class="input-wrapper">
                  <Field
                    as="select"
                    class="form-control custom-select"
                    v-model="wing"
                    name="wing"
                    id="select4"
                  >
                    <option selected>{{ $t("select_wing") }}</option>
                    <option value="1">{{ $t("wisdom") }}</option>
                    <option value="2">{{ $t("youth") }}</option>
                    <option value="3">{{ $t("students") }}</option>
                    <option value="4">{{ $t("women") }}</option>
                    <option value="5">{{ $t("balavedi") }}</option>
                    <option value="6">{{ $t("girls") }}</option>
                  </Field>
                </div>
                <ErrorMessage name="wing" class="error-feedback" />
              </div>

              <div class="form-group basic">
                <label class="label" for="associated">{{
                  $t("associated")
                }}</label>

                <div class="associated-grid" v-if="associatedOptions.length">
                  <div
                    v-for="associated in associatedOptions"
                    :key="associated.id"
                    class="associated-item"
                    :class="{ selected: isAssociatedSelected(associated) }"
                    @click="toggleAssociatedSelection(associated)"
                  >
                    <input
                      type="checkbox"
                      class="associated-checkbox"
                      :checked="isAssociatedSelected(associated)"
                      @change="toggleAssociatedSelection(associated)"
                      :disabled="loading"
                      @click.stop
                    />
                    <span class="associated-name">{{ associated.name }}</span>
                  </div>
                </div>

                <!-- Error Message -->
                <div
                  class="text-danger small mt-1"
                  v-if="associatedSelectionError"
                >
                  {{ associatedSelectionError }}
                </div>

                <!-- Selected Count -->
                <div class="selected-count" v-if="selectedAssociated.length">
                  <small class="text-muted">
                    {{ associatedOptions.length }}
                    {{ $t("of") }}
                    {{ selectedAssociated.length }} {{ $t("options_selected") }}
                  </small>
                </div>
              </div>

              <div class="form-group basic">
                <label class="label" for="panchayath">{{
                  $t("panchayath")
                }}</label>
                <select
                  v-model="selectedPanchayath"
                  @change="onPanchayathChange"
                  class="form-control"
                  id="panchayath"
                  required
                >
                  <option value="" selected>
                    {{ $t("select_panchayath_type") }}
                  </option>
                  <option v-for="p in panchayaths" :key="p.id" :value="p.id">
                    {{
                      $i18n.locale === "ml" && p.name_mal ? p.name_mal : p.name
                    }}
                  </option>
                </select>
              </div>
              <div
                class="form-group basic"
                v-if="selectedPanchayath && wards.length"
              >
                <label class="label" for="ward">{{ $t("cluster") }}</label>
                <select
                  v-model="selectedWard"
                  name="selectedWard"
                  class="form-control"
                  id="ward"
                  required
                >
                  <option value="">{{ $t("select_cluster") }}</option>
                  <option v-for="w in wards" :key="w.id" :value="w.id">
                    {{
                      $i18n.locale === "ml" && w.name_mal ? w.name_mal : w.name
                    }}
                  </option>
                </select>
                <ErrorMessage name="selectedWard" class="text-danger small" />
              </div>
              <div class="form-group basic">
                <button
                  type="submit"
                  class="btn btn-primary btn-block btn-lg"
                  :disabled="loading"
                  v-if="permissions.members.update"
                >
                  <span
                    v-show="loading"
                    class="spinner-border spinner-border-sm"
                  ></span>
                  <span>{{ $t("save") }}</span>
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-block btn-lg"
                  v-if="!permissions.members.update && !add_admin"
                  @click="closeAddMemberModel"
                >
                  {{ $t("cancel") }}
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- DeleteMemberModel -->
  <div
    class="modal fade action-sheet"
    id="deleteMemberModel"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t("delete_member") }}</h5>
        </div>
        <div class="modal-body">
          <div class="action-sheet-content">
            <div class="form-group" v-if="message_delete">
              <div v-if="message_delete" class="error-feedback">
                {{ message_delete }}
              </div>
            </div>
            <div class="form-group basic">
              <label class="label" for="stay"
                ><span class="mal-text">{{
                  $t("reason_to_delete")
                }}</span></label
              >
              <div class="form-group boxed">
                <div class="input-wrapper mal-text">
                  <select
                    as="select"
                    class="form-control custom-select"
                    v-model="reason_to_delete"
                    name="stay"
                    id="select4"
                    @change="adminDeleteChange($event)"
                  >
                    <option value>{{ $t("select_reason_to_delete") }}</option>
                    <option value="തെറ്റായി ചേർത്തതാണ്">
                      {{ $t("incorrectly_added") }}
                    </option>
                    <option value="Other">{{ $t("other_reason") }}</option>
                  </select>
                </div>
                <input type="hidden" v-model="deletable_id" />
              </div>
            </div>
            <div class="form-group basic" v-if="delete_others">
              <label class="label" for="Name"
                ><span class="mal-text">{{
                  $t("reason_to_delete")
                }}</span></label
              >
              <div class="form-group boxed">
                <Field
                  name="name"
                  type="text"
                  class="form-control"
                  v-model="delete_other_text"
                  placeholder="{{ $t('reason_to_delete_explain') }}"
                  autocomplete="off"
                />
              </div>
            </div>

            <div class="form-group basic">
              <button
                type="button"
                @click="memberDelete()"
                class="btn btn-primary btn-block btn-lg"
                :disabled="loading"
              >
                <span
                  v-show="loading"
                  class="spinner-border spinner-border-sm"
                ></span>
                <span>{{ $t("delete") }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- verificationModelModel -->
  <div
    class="modal fade action-sheet"
    id="verificationModel"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t("member_status") }}</h5>
        </div>
        <div class="modal-body">
          <div class="action-sheet-content">
            <div class="form-group" v-if="verification_message">
              <div v-if="verification_message" class="error-feedback">
                {{ verification_message }}
              </div>
            </div>
            <div class="form-group basic">
              <label class="label" for="stay"
                ><span>{{ $t("membership_status") }}</span></label
              >
              <div class="form-group">
                <div class="input-wrapper">
                  <select
                    as="select"
                    class="form-control custom-select"
                    v-model="verification_status"
                    name="stay"
                    id="select4"
                  >
                    <option value>---{{ $t("select_option") }}---</option>
                    <option value="1">{{ $t("member") }}</option>
                    <option value="0">{{ $t("not_a_member") }}</option>
                  </select>
                </div>
                <input type="hidden" v-model="member_id" />
              </div>
            </div>
            <div class="form-group basic">
              <label class="label" for="Remarks"
                ><span>{{ $t("remarks") }}</span></label
              >
              <div class="form-group">
                <Field
                  name="verification_remark"
                  type="text"
                  class="form-control"
                  v-model="verification_remark"
                  placeholder="Remarks"
                  autocomplete="off"
                />
              </div>
            </div>

            <div class="form-group basic">
              <button
                type="button"
                @click="memberVerify()"
                class="btn btn-primary btn-block btn-lg"
                :disabled="loading"
              >
                <span
                  v-show="loading"
                  class="spinner-border spinner-border-sm"
                ></span>
                <span>{{ $t("save") }}</span>
              </button>
            </div>
          </div>
          <div
            class="action-sheet-content"
            v-if="currentUser.user_level <= 4 && verification_report"
          >
            <div class="form-group basic">
              <label class="label mal-text" for="stay"
                ><span>{{ $t("verification_status") }}</span></label
              >
              <h4
                class="mal-text text-success"
                v-if="verification_status == 'Y'"
              >
                {{ $t("verification_completed") }}
              </h4>
              <h4
                class="mal-text text-danger"
                v-if="verification_status == 'N'"
              >
                {{ $t("verification_not_completed") }}
              </h4>
            </div>
            <div
              class="form-group basic"
              v-if="verification_status == 'N' && not_verification_status"
            >
              <label class="label mal-text" for="stay"
                ><span>{{ $t("reason_for_not_verification") }}</span></label
              >
              <h4 class="mal-text text-danger" v-if="not_verification_status_">
                {{ not_verification_status_ }}
              </h4>
            </div>
            <div class="form-group basic" v-if="verification_remark">
              <label class="label mal-text" for="Remarks"
                ><span>{{ $t("note") }}</span></label
              >
              <h4 class="mal-text text-primary">{{ verification_remark }}</h4>
            </div>

            <div class="form-group basic">
              <button
                type="button"
                class="btn btn-primary btn-block btn-lg"
                @click="closeVerificationModel"
              >
                <span>{{ $t("close") }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Youth Conference -->
  <!-- <div class="modal fade action-sheet" id="addAbroadModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">ഇപ്പോഴത്തെ സ്റ്റാറ്റസ്</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <Form @submit="addAbroad">
                            <div class="form-group basic">
                                <label class="label" for="stay"><span>സ്റ്റാറ്റസ്</span></label>
                                <div class="input-wrapper">
                                    <select as="select" class="form-control custom-select" v-model="isAbroad"
                                        name="isAbroad" id="select4">
                                        <option value=''>---Select---</option>
                                        <option value="നാട്ടിൽ ഉണ്ട് ആക്റ്റീവ് ആണ്">നാട്ടിൽ ഉണ്ട് ആക്റ്റീവ് ആണ്</option>
                                        <option value="നാട്ടിൽ ഉണ്ട് ആക്റ്റീവ് അല്ല">നാട്ടിൽ ഉണ്ട് ആക്റ്റീവ് അല്ല
                                        </option>
                                        <option value="വിദേശത്ത് ആണ്">വിദേശത്ത് ആണ്</option>
                                        <option value="ഒരു വിവരവും ഇല്ല">ഒരു വിവരവും ഇല്ല</option>
                                    </select>
                                </div>
                                <input type="hidden" v-model="member_id" />
                            </div>
                            <div class="form-group basic" v-if="isAbroad == 'വിദേശത്ത് ആണ്'">
                                <label class="label" for="stay"><span>രാജ്യം</span></label>
                                <div class="input-wrapper">
                                    <select as="select" class="form-control custom-select" v-model="abroadCountry"
                                        name="abroadCountry" id="select4">
                                        <option v-for="item in country_list" :value="item.item_value"
                                            v-bind:key="item.item_value">
                                            {{ item.name }}</option>
                                    </select>
                                </div>
                                <input type="hidden" v-model="member_id" />
                            </div>

                            <div class="form-group basic" v-if="isAbroad == 'വിദേശത്ത് ആണ്'">
                                <label class="label" for="abroadPlace"><span>സ്ഥലം</span></label>
                                <div class="input-wrapper">
                                    <Field name="abroadPlace" type="text" class="form-control" v-model="abroadPlace"
                                        placeholder="Place" autocomplete="off" />
                                </div>
                            </div>
                            <div class="form-group basic" v-if="isAbroad == 'വിദേശത്ത് ആണ്'">
                                <label class="label" for="abroadMobile"><span>വിദേശത്തെ മൊബൈൽ നമ്പർ</span></label>
                                <div class="input-wrapper">
                                    <Field name="abroadMobile" type="text" class="form-control" v-model="abroadMobile"
                                        placeholder="Mobile" autocomplete="off" />
                                </div>
                            </div>
                            <div class="form-group" v-if="message">
                                <div v-if="message" class="error-feedback">
                                    {{ message }}
                                </div>
                            </div>

                            <div class="form-group basic">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="loading"
                                    v-if="currentUser.user_level <= 4">
                                    <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                    <span>Save</span></button>
                                <button type="button" class="btn btn-primary btn-block btn-lg"
                                    v-if="currentUser.user_level > 4" @click="closeAddAdminModel">Close</button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

  <!-- Move to Karad List Modal -->
  <div
    class="modal fade action-sheet"
    id="moveToKaradModel"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t("move_to_karad_list") }}</h5>
        </div>
        <div class="modal-body">
          <div class="action-sheet-content">
            <Form @submit="moveToKaradSubmit" :validation-schema="karadSchema">
              <div class="form-group basic">
                <label class="label" for="karadName">{{ $t("name") }}</label>
                <Field
                  name="karadName"
                  type="text"
                  class="form-control"
                  id="karadName"
                  v-model="karadForm.name"
                  :placeholder="$t('enter_name')"
                  autocomplete="off"
                />
                <ErrorMessage name="karadName" class="error-feedback" />
              </div>
              <div class="form-group basic">
                <label class="label" for="karadAge">{{ $t("age") }}</label>
                <Field
                  name="karadAge"
                  type="number"
                  class="form-control"
                  id="karadAge"
                  v-model="karadForm.age"
                  :placeholder="$t('enter_age')"
                  autocomplete="off"
                />
                <ErrorMessage name="karadAge" class="error-feedback" />
              </div>
              <div class="form-group basic">
                <div class="input-wrapper">
                  <label class="label text-primary" for="karadJob">
                    {{ $t("job") }}
                  </label>
                  <Field
                    name="karadJob"
                    as="select"
                    class="form-control"
                    v-model="karadForm.job"
                  >
                    <option value="">{{ $t("select_profession") }}</option>
                    <option
                      v-for="item in profession_list"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ $i18n.locale === "en" ? item.name : item.name_mal }}
                    </option>
                  </Field>
                  <ErrorMessage name="karadJob" class="error-feedback" />
                </div>
              </div>
              <div class="form-group" v-if="karadMessage">
                <div v-if="karadMessage" class="error-feedback">
                  {{ karadMessage }}
                </div>
              </div>
              <div class="form-group basic">
                <div class="input-wrapper row">
                  <label class="label" for="karadCountryCode">{{
                    $t("mobile_number")
                  }}</label>
                  <div class="form-group" style="width: 30% !important">
                    <div class="input-wrapper">
                      <Field
                        as="select"
                        class="form-control custom-select"
                        v-model="karadForm.country_code"
                        name="karadCountryCode"
                        id="karadCountryCode"
                      >
                        <option
                          v-for="item in country_code_list"
                          :value="item.item_value"
                          v-bind:key="item.item_value"
                        >
                          {{ item.name }}
                        </option>
                      </Field>
                    </div>
                  </div>
                  <div
                    class="form-group mobile-field"
                    style="width: 68% !important; margin-left: 2%"
                  >
                    <div class="input-wrapper">
                      <Field
                        name="karadMobileNumber"
                        type="number"
                        id="karadMobileNumber"
                        class="form-control"
                        placeholder=""
                        autocomplete="off"
                        v-model="karadForm.mobile_number"
                        oninput="javascript: this.value.replace(/[\s\/]/g,''); if(this.value.charAt(0) == 0){ this.value = this.value.slice(1, 11); } if(this.value.length > 10) { this.value = this.value.slice(0, 10);} "
                      />
                    </div>
                  </div>
                  <ErrorMessage
                    name="karadMobileNumber"
                    class="error-feedback"
                  />
                </div>
              </div>
              <div class="form-group basic">
                <div class="input-wrapper row">
                  <label class="label" for="karadWhatsappCountryCode"
                    >{{ $t("whatsapp_number") }}
                    <small class="text-muted"
                      >({{ $t("optional") }})</small
                    ></label
                  >
                  <div class="form-group" style="width: 30% !important">
                    <div class="input-wrapper">
                      <Field
                        as="select"
                        class="form-control custom-select"
                        v-model="karadForm.country_code_whatsapp"
                        name="karadWhatsappCountryCode"
                        id="karadWhatsappCountryCode"
                      >
                        <option
                          v-for="item in country_code_list"
                          :value="item.item_value"
                          v-bind:key="item.item_value"
                        >
                          {{ item.name }}
                        </option>
                      </Field>
                    </div>
                  </div>
                  <div
                    class="form-group mobile-field"
                    style="width: 68% !important; margin-left: 2%"
                  >
                    <div class="input-wrapper">
                      <Field
                        name="karadWhatsappNumber"
                        type="number"
                        id="karadWhatsappNumber"
                        class="form-control"
                        placeholder=""
                        autocomplete="off"
                        v-model="karadForm.whatsapp_number"
                        oninput="javascript: this.value.replace(/[\s\/]/g,''); if(this.value.charAt(0) == 0){ this.value = this.value.slice(1, 11); } if(this.value.length > 10) { this.value = this.value.slice(0, 10);} "
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group basic">
                <label class="label" for="karadWing">{{ $t("wing") }}</label>
                <div class="input-wrapper">
                  <Field
                    as="select"
                    class="form-control custom-select"
                    v-model="karadForm.wing"
                    name="karadWing"
                    id="karadWing"
                  >
                    <option value="">{{ $t("select_wing") }}</option>
                    <option value="1">{{ $t("wisdom") }}</option>
                    <option value="2">{{ $t("youth") }}</option>
                    <option value="3">{{ $t("students") }}</option>
                    <option value="4">{{ $t("women") }}</option>
                    <option value="5">{{ $t("balavedi") }}</option>
                    <option value="6">{{ $t("girls") }}</option>
                  </Field>
                </div>
                <ErrorMessage name="karadWing" class="error-feedback" />
              </div>

              <div class="form-group basic">
                <label class="label" for="karadAssociated">{{
                  $t("associated")
                }}</label>

                <div class="associated-grid" v-if="associatedOptions.length">
                  <div
                    v-for="associated in associatedOptions"
                    :key="associated.id"
                    class="associated-item"
                    :class="{ selected: isKaradAssociatedSelected(associated) }"
                    @click="toggleKaradAssociatedSelection(associated)"
                  >
                    <input
                      type="checkbox"
                      class="associated-checkbox"
                      :checked="isKaradAssociatedSelected(associated)"
                      @change="toggleKaradAssociatedSelection(associated)"
                      :disabled="loading"
                      @click.stop
                    />
                    <span class="associated-name">{{
                        associated.name
                    }}</span>
                  </div>
                </div>

                <!-- Error Message -->
                <div
                  class="text-danger small mt-1"
                  v-if="karadAssociatedSelectionError"
                >
                  {{ karadAssociatedSelectionError }}
                </div>

                <!-- Selected Count -->
                <div
                  class="selected-count"
                  v-if="
                    karadForm &&
                    karadForm.selectedAssociated &&
                    karadForm.selectedAssociated.length
                  "
                >
                  <small class="text-muted">
                    {{ karadForm.selectedAssociated.length }} {{ $("of") }}
                    {{ associatedOptions.length }} {{ $t("options_selected") }}
                  </small>
                </div>
              </div>

              <div class="form-group basic">
                <label class="label" for="karadPanchayath"
                  >{{ $t("panchayath") }}
                  <small class="text-muted">{{ $t("optional") }}</small></label
                >
                <select
                  v-model="karadForm.selectedPanchayath"
                  @change="onKaradPanchayathChange"
                  class="form-control"
                  id="karadPanchayath"
                >
                  <option value="">{{ $t("select_panchayath") }}</option>
                  <option v-for="p in panchayaths" :key="p.id" :value="p.id">
                    {{
                      $i18n.locale === "ml" && p.name_mal ? p.name_mal : p.name
                    }}
                  </option>
                </select>
              </div>
              <div
                class="form-group basic"
                v-if="
                  karadForm && karadForm.selectedPanchayath && karadWards.length
                "
              >
                <label class="label" for="karadWard"
                  >{{ $t("cluster") }}
                  <small class="text-muted">{{ $t("optional") }}</small></label
                >
                <select
                  v-model="karadForm.selectedWard"
                  name="karadSelectedWard"
                  class="form-control"
                  id="karadWard"
                >
                  <option value="">{{ $t("select_cluster") }}</option>
                  <option v-for="w in karadWards" :key="w.id" :value="w.id">
                    {{
                      $i18n.locale === "ml" && w.name_mal ? w.name_mal : w.name
                    }}
                  </option>
                </select>
              </div>
              <div class="form-group basic">
                <button
                  type="submit"
                  class="btn btn-primary btn-block btn-lg"
                  :disabled="loading"
                >
                  <span
                    v-show="loading"
                    class="spinner-border spinner-border-sm"
                  ></span>
                  <span>{{ $t("save_move_to_karad") }}</span>
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-block btn-lg mt-2"
                  @click="closeMoveToKaradModel"
                >
                  {{ $t("cancel") }}
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- * verificationModel -->
  <!-- <div class="section pt-1 mt-1">
        <button type="button" class="btn btn-primary btn-sm me-1 mb-1" @click="adminAdd" v-if="editable">
            <ion-icon name="add-outline"></ion-icon>
            Add
        </button>
    </div>
    <div id="search">
        <form class="search-form">
            <div class="form-group searchbox">
                <input type="text" class="form-control" placeholder="ഇവിടെ സെർച്ച് ചെയ്യുക..." v-model="search_qty"
                    @input="filteredMembers()">
                <i class="input-icon">
                    <ion-icon name="search-outline"></ion-icon>
                </i>
            </div>
        </form>
    </div> -->
  <div class="section pt-1 mt-1">
    <div class="d-flex align-items-center gap-2">
      <!-- Search Form - takes remaining space -->
      <div class="flex-grow-1">
        <form class="search-form">
          <div class="form-group searchbox mb-0">
            <input
              type="text"
              class="form-control"
              :placeholder="$t('search')"
              v-model="search_qty"
              @input="filteredMembers()"
            />
            <i class="input-icon">
              <ion-icon name="search-outline"></ion-icon>
            </i>
          </div>
        </form>
      </div>

      <!-- Add Button with Icon Only -->
      <button
        type="button"
        class="btn btn-primary btn-sm"
        @click="adminAdd"
        v-if="permissions.members.update"
        title="Add Member"
      >
        <ion-icon name="add-outline"></ion-icon>
        {{ $t("add") }}
      </button>
    </div>
  </div>
  <div class="section text-center mt-2" v-if="loading_list">
    <div class="spinner-border text-secondary" role="status"></div>
  </div>
  <ul
    class="listview image-listview inset text mt-0 mb-2 mt-2"
    v-if="!loading_list && temp_member_lists.length"
  >
    <li
      v-for="(member_list, index) in temp_member_lists"
      v-bind:key="member_list.id"
      :set="
        (background =
          member_list.fillStatus <= 0 ? 'rgb(242 187 202)' : '#ffffff')
      "
      :style="{ 'background-color': background }"
    >
      <a href="javascript:void(0)" class="item">
        <span class="sl-no">{{ index + 1 }}</span>
        <div class="avatar-section">
          <a href="#">
            <img
              v-if="
                member_list.avatar != 'member.jpg' && member_list.avatar != null
              "
              :src="'https://guide.msoftit.com/' + member_list.avatar"
              alt="avatar"
              class="image"
            />
            <img
              v-if="!member_list.avatar || member_list.avatar == 'member.jpg'"
              :src="'assets/img/sample/avatar/avatar1.png'"
              alt="avatar"
              class="image"
            />
            <span
              class="button verified"
              v-if="member_list.converted_to_karad == 'Y'"
            >
              <ion-icon name="checkmark-outline"></ion-icon>
            </span>
            <span
              class="button not-verified"
              v-if="member_list.converted_to_karad == 'N'"
            >
              <ion-icon name="close-outline"></ion-icon>
            </span>
          </a>
        </div>
        <div class="in">
          <div class="min-width-50">
            <!-- <header>User</header> -->
            <b> {{ member_list.name }} </b>
            <footer>
              {{ member_list.country_code }} {{ member_list.mobile
              }}<span
                class="qhls-text"
                v-if="
                  (permissions.qhls ? permissions.qhls.view : false) &&
                  member_list.qhls_reg == 1
                "
                >,{{ unit.qhls_register_text }}</span
              >
              <br />
              <span
                v-if="
                  member_list.wing == 3 &&
                  ((member_list.studyOrJob == 'Study' &&
                    parseInt(member_list.studyLevel) >= 349 &&
                    (!member_list.studyCampus ||
                      !member_list.studyCourse ||
                      !member_list.studyCampus ||
                      !member_list.institution)) ||
                    (parseInt(member_list.studyLevel) == 347 &&
                      !member_list.studySubLevel))
                "
                ><b class="error-feedback mal-text">{{
                  $t("education_required")
                }}</b></span
              >
              <div
                class="form-check form-check-inline"
                v-if="currentUser.testing_user == 'Y5388'"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  :checked="member_list.verified == 'Y'"
                  :id="'inlineCheckbox' + member_list.id"
                  value="1"
                  v-model="verification_check[member_list.id]"
                  @click="verificationCheckClick(1, member_list.id)"
                />
                <label
                  class="form-check-label green-tick"
                  :for="'inlineCheckbox' + member_list.id"
                >
                  <ion-icon name="checkmark-outline"></ion-icon>
                </label>
              </div>
              <div
                class="form-check form-check-inline"
                v-if="currentUser.testing_user == 'Y5388'"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  :checked="
                    member_list.verified == 'N' &&
                    member_list.verification_status
                  "
                  :id="'inlineCheckbox_' + member_list.id"
                  value="0"
                  v-model="not_verification_check[member_list.id]"
                  @click="verificationCheckClick(0, member_list.id)"
                />
                <label
                  class="form-check-label red-cross"
                  :for="'inlineCheckbox_' + member_list.id"
                >
                  <ion-icon name="close-outline"></ion-icon>
                </label>
              </div>
            </footer>
          </div>
          <div
            class="progress float-right"
            v-if="member_list.fillStatus > 0 && member_list.verified != 'Y'"
            :set="
              (background_ =
                member_list.fillStatus >= 100 ? '#059205' : '#1a418c')
            "
          >
            <div
              class="progress-bar"
              role="progressbar"
              :style="{
                width: member_list.fillStatus + '%',
                background: background_,
              }"
              aria-valuenow="85"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {{ member_list.fillStatus }}%
            </div>
          </div>
          <div class="card-button dropdown">
            <button
              type="button"
              class="btn btn-link btn-icon"
              data-bs-toggle="modal"
              :data-bs-target="'#actionSheetInset' + member_list.id"
              @click="showActionModel"
            >
              <ion-icon name="ellipsis-vertical-outline"></ion-icon>
            </button>
          </div>

          <!-- Default Action Sheet Inset -->
          <div
            class="modal fade action-sheet"
            :id="'actionSheetInset' + member_list.id"
            tabindex="-1"
            role="dialog"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">{{ $t("action") }}</h5>
                </div>
                <div class="modal-body">
                  <ul class="action-button-list">
                    <li v-if="this.permissions.members.call">
                      <a
                        :href="'tel:' + member_list.mobile"
                        class="btn btn-list"
                      >
                        <span>
                          <ion-icon name="call-outline"></ion-icon>
                          {{ $t("call") }}
                        </span>
                      </a>
                    </li>
                    <li
                      v-if="
                        member_list.whatsapp &&
                        this.permissions.members.whatsapp
                      "
                    >
                      <a
                        :href="
                          'https://wa.me/' +
                          member_list.whatsapp_country_code +
                          member_list.whatsapp +
                          '?text='
                        "
                        class="btn btn-list"
                      >
                        <span>
                          <ion-icon name="logo-whatsapp"></ion-icon>
                          {{ $t("whatsapp") }}
                        </span>
                      </a>
                    </li>
                    <li v-if="permissions.members.update">
                      <a
                        href="javascript:void(0)"
                        @click="memberView(member_list)"
                        class="btn btn-list"
                        data-bs-dismiss="modal"
                      >
                        <span>
                          <ion-icon name="pencil-outline"></ion-icon>
                          {{ $t("edit") }}
                        </span>
                      </a>
                    </li>
                    <li v-if="permissions.members.delete">
                      <a
                        href="javascript:void(0)"
                        @click="adminDelete(member_list)"
                        class="btn btn-list"
                        data-bs-dismiss="modal"
                      >
                        <span>
                          <ion-icon name="trash-outline"></ion-icon>
                          {{ $t("remove") }}
                        </span>
                      </a>
                    </li>

                    <li
                      v-if="
                        permissions.members.move_to_member &&
                        member_list.converted_to_karad == 'N'
                      "
                    >
                      <a
                        href="javascript:void(0)"
                        class="btn btn-list"
                        data-bs-dismiss="modal"
                        @click="moveToKaradList(member_list)"
                      >
                        <span>
                          <ion-icon name="list-outline"></ion-icon>
                          {{ $t("move_to_karad_list") }}
                        </span>
                      </a>
                    </li>
                    <li class="action-divider"></li>
                    <li>
                      <a
                        href="#"
                        class="btn btn-list text-danger"
                        data-bs-dismiss="modal"
                      >
                        <span>
                          <ion-icon name="close-outline"></ion-icon>
                          {{ $t("cancel") }}
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- * Default Action Sheet Inset -->
        </div>
      </a>
    </li>
  </ul>
  <div
    class="section text-center"
    v-if="!loading_list && temp_member_lists.length == 0"
  >
    <b>{{ $t("no_data") }}</b>
  </div>
  <alert-model
    :type="alert_type"
    :message="alert_message"
    ref="alert_model"
  ></alert-model>
  <dialog-model
    :message="dialog_message"
    :action_method="dialog_action"
    :action_method_params="dialog_action_params"
    ref="dialog_model"
  ></dialog-model>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import UserService from "../../services/user.service";
import $ from "jquery";

import AlertModel from "../layouts/AlertModel.vue";
import DialogModel from "../layouts/DialogModel.vue";

export default {
  name: "Directory List",

  components: {
    Form,
    Field,
    ErrorMessage,
    AlertModel,
    DialogModel,
  },
  data() {
    const nameRegex = /^[a-zA-Z0-9&._-\s]*$/g;
    const schema = yup.object().shape({
      name: yup
        .string()
        .matches(nameRegex, this.$t("name_regex"))
        .required(this.$t("name_required")),
      job: yup.string().required(this.$t("job_required")),
      mobile_number: yup.string().required(this.$t("mobile_required")),
      wing: yup.string().required(this.$t("wing_required")),
    });

    const karadSchema = yup.object().shape({
      karadName: yup
        .string()
        .matches(nameRegex, this.$t("name_regex"))
        .required(this.$t("name_required")),
      karadAge: yup.string().nullable().required(this.$t("age_required")),
      karadJob: yup.string().required(this.$t("job_required")),
      karadMobileNumber: yup.string().required(this.$t("mobile_required")),
      karadWing: yup.string().required(this.$t("wing_required")),
    });
    return {
      loading: false,
      loading_list: false,
      message: "",
      country_code: "91",
      country_code_whatsapp: "91",
      mobile_number: "",
      whatsapp_number: "",
      wing: "",
      cluster: "",
      schema,
      karadSchema,
      stay: "",
      user_level: "",
      sub_levels: [],
      member_lists: [],
      temp_member_lists: [],
      orgnal_member_lists: [],
      trash_list: [],
      unit: [],
      editable_id: "",
      editable: true,
      add_admin: false,
      abroad_fields: false,
      deletable_id: "",
      reason_to_delete: "",
      message_delete: "",
      delete_others: false,
      delete_other_text: "",
      member_id: "",
      search_qty: "",
      country_list: [],
      permissions: {
        view_event_registrations: "",
        executives: [],
        members: [],
      },
      selectedPanchayath: null,
      selectedWard: null,
      panchayaths: [],
      wards: [],
      age: "",
      associated: "",
      selectedAssociated: [],
      profession_list: [],
      formData: {
        job: "",
      },
      unit_id: "",
      associatedOptions: [
        { value: this.$t('asso_value_1'), name: this.$t('associated_1') },
        { value: this.$t('asso_value_2'), name: this.$t('associated_2') },
        { value: this.$t('asso_value_3'), name: this.$t('associated_3') },
        { value: this.$t('asso_value_4'), name: this.$t('associated_4') },
        { value: this.$t('asso_value_5'), name: this.$t('associated_5') },
        { value: this.$t('asso_value_6'), name: this.$t('associated_6') },
        { value: this.$t('asso_value_7'), name: this.$t('associated_7') },
        { value: this.$t('asso_value_8'), name: this.$t('associated_8') },
        { value: this.$t('asso_value_9'), name: this.$t('associated_9') },
        { value: this.$t('asso_value_10'), name: this.$t('associated_10') },
        { value: this.$t('asso_value_11'), name: this.$t('associated_11') },
        { value: this.$t('asso_value_12'), name: this.$t('associated_12') },
        { value: this.$t('asso_value_13'), name: this.$t('associated_13') },
        { value: this.$t('asso_value_14'), name: this.$t('associated_14') },
        { value: this.$t('asso_value_15'), name: this.$t('associated_15') },
        { value: this.$t('asso_value_16'), name: this.$t('associated_16') },
        { value: this.$t('asso_value_17'), name: this.$t('associated_17') },
        { value: this.$t('asso_value_18'), name: this.$t('associated_18') }
    ],
      // Karad List specific data
      karadForm: {
        id: null,
        name: "",
        age: "",
        job: "",
        mobile_number: "",
        country_code: "91",
        whatsapp_number: "",
        country_code_whatsapp: "91",
        wing: "",
        selectedAssociated: [],
        selectedPanchayath: null,
        selectedWard: null,
      },
      karadMessage: "",
      karadWards: [],
      karadAssociatedSelectionError: "",
    };
  },

  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  mounted() {
    console.log(this.permissions.verification);
    if (!this.currentUser) {
      location.replace("/");
    } else {
      this.user_level = parseInt(this.$route.params.sub_level);
      this.unit_id = parseInt(this.$route.params.id);
      this.getMembersList(1);
      this.$root.updateParent("Dawa Directory");
    }
    this.getComboboxValues("COUNTRY");
    this.getComboboxValues("COUNTRY_CODE");
    this.getComboboxValues("YOUTH_DIRECTORY_PROFESSION");
    this.loadUserDistrictAndPanchayaths();
    window.onpopstate = function () {
      if ($("body").hasClass("modal-open")) {
        location.reload();
      }
    };
  },
  methods: {
    getComboboxValues(code, id = null) {
      var data = {
        code: code,
        type_id: id,
      };
      UserService.getCombobox(data).then(
        (response) => {
          switch (code) {
            case "COUNTRY_CODE":
              this.country_code_list = response.data.data.list.options;
              break;
            case "COUNTRY":
              this.country_list = response.data.data.list.options;
              break;

            case "UNVERIFIED_REASON":
              this.verification_status_list = response.data.data.list.options;
              break;

            case "YOUTH_DIRECTORY_PROFESSION":
              this.profession_list = response.data.data.list.options;
              break;

            default:
              break;
          }
        },
        (error) => {
          this.loading = false;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },
    getMembersList(wing) {
      this.loading_list = true;
      let data = {
        unit_id: this.unit_id ? this.unit_id : this.currentUser.unit_id,
        wing: wing,
        members_list: false,
        temp_members_list: true,
      };
      UserService.authPostRequest("get-dawa-directories", data).then(
        (response) => {
          if (response.data.status == "success") {
            this.member_lists = response.data.data.list;
            this.search_qty = "";
            this.orgnal_member_lists = response.data.data.list;
            this.trash_list = response.data.data.trash_list;
            this.temp_member_lists = response.data.data.list;
            this.unit = response.data.data.unit;
            this.wing = wing;
            this.permissions = response.data.data.permissions;
            this.loading_list = false;
          } else if (response.data.status == "error") {
            this.$swal("", response.data.message, "error");
            this.loading_list = false;
          } else {
            this.loading_list = true;
          }
        },
        (error) => {
          this.loading = false;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },
    memberView(admin) {
      $("#addMemberModel").modal("show");
      this.wing = admin.wing;
      this.mobile_number = admin.mobile;
      this.name = admin.name;
      this.age = admin.age;

      if (admin.job) {
        try {
          const jobArray = JSON.parse(admin.job);
          this.formData.job = jobArray.length > 0 ? jobArray[0] : "";
        } catch (e) {
          this.formData.job = admin.job;
        }
      } else {
        this.formData.job = "";
      }

      if (admin.associated) {
        try {
          const associatedArray = JSON.parse(admin.associated);
          this.selectedAssociated = this.associatedOptions.filter((option) =>
            associatedArray.includes(option.value)
          );
        } catch (e) {
          // If it's not JSON, treat as single value (backward compatibility)
          this.selectedAssociated = this.associatedOptions.filter(
            (option) => option.value === admin.associated
          );
        }
      } else {
        this.selectedAssociated = [];
      }
      console.log(admin);

      this.selectedPanchayath = admin.panchayath_id;
      this.onPanchayathChange();
      this.selectedWard = admin.cluster_id;

      this.country_code = admin.country_code;
      this.editable_id = admin.id;
      if (admin.country_code != "91") {
        this.whatsapp_number = admin.whatsapp;
        this.country_code_whatsapp =
          admin.whatsapp_country_code != ""
            ? admin.whatsapp_country_code
            : "91";
        this.abroad_fields = true;
      } else {
        this.abroad_fields = false;
      }

      this.add_admin = false;
    },

    associatedLabel(option) {
      return option.name;
    },

    adminDeleteChange(event) {
      if (event.target.value == "Other") {
        this.delete_others = true;
      } else {
        this.delete_others = false;
      }
    },
    adminDelete(member) {
      this.deletable_id = member.id;
      $("#deleteMemberModel").modal("show");
    },
    memberDelete() {
      if (this.reason_to_delete) {
        this.message_delete = "";
        var data = {
          id: this.deletable_id,
          reason: !this.delete_others
            ? this.reason_to_delete
            : this.delete_other_text,
        };
        UserService.authPostRequest("delete-dawa-directories", data).then(
          (response) => {
            if (response.data.status == "success") {
              this.deletable_id = "";
              this.reason_to_delete = "";
              this.delete_others = false;
              this.delete_other_text = "";
              $("#deleteMemberModel").modal("hide");
              this.$swal.fire("", response.data.message, "success");
              this.getMembersList(1);
              this.loading = false;
            } else if (response.data.status == "warning") {
              $("#deleteMemberModel").modal("hide");
              this.$swal.fire("", response.data.message, "warning");
              this.getMembersList(1);
              this.loading = false;
            } else {
              this.loading = true;
            }
          },
          (error) => {
            this.loading = false;
            this.message =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        );
      } else {
        this.message_delete = "ഡിലീറ്റ് ചെയ്യാനുള്ള കാരണം സെലക്ട് ചെയ്യുക";
      }
    },
    goToBiodata(member_list) {
      this.$router.push("/bio-data/" + member_list.user_id);
    },
    showActionModel() {
      // Removed pin_number functionality
    },
    adminAdd() {
      $("#addMemberModel").modal("show");
      this.wing = "";
      this.mobile_number = "";
      this.name = "";
      this.country_code = "91";
      this.editable_id = null;
      this.selectedAssociated = [];
      this.add_admin = true;
      this.age = "";
      this.formData.job = "";
      this.associated = "";
    },
    addMember(user) {
      user.id = this.editable_id;
      user.unit_id = this.unit_id ? this.unit_id : this.currentUser.unit_id;
      user.added_by = this.currentUser.id;
      user.type = "temp_member";
      user.panchayath_id = this.selectedPanchayath;
      user.cluster_id = this.selectedWard;
      user.age = this.age;
      user.job = JSON.stringify([this.formData.job]);
      user.associated = JSON.stringify(
        this.selectedAssociated.map((option) => option.value)
      );
      this.loading = true;
      UserService.authPostRequest("store-dawa-directories", user).then(
        (response) => {
          if (response.data.status == "success") {
            $("#addMemberModel").modal("hide");
            this.$swal("", response.data.message, "success");
            this.getMembersList(user.wing);
            this.loading = false;
          } else if (
            response.data.status == "error" ||
            response.data.status == "warning"
          ) {
            $("#addMemberModel").modal("hide");
            this.$swal("", response.data.message, response.data.status);
            this.loading = false;
          } else {
            this.loading = false;
          }
        },
        (error) => {
          this.loading = false;
          $("#addMemberModel").modal("hide");
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.$swal("", this.message, "error");
        }
      );
    },
    closeAddMemberModel() {
      $("#addMemberModel").modal("hide");
    },
    closeVerificationModel() {
      $("#verificationModel").modal("hide");
    },
    closeLajnaModel() {
      $("#lajnaMemberModel").modal("hide");
    },
    onChangeCountryCode(event) {
      if (event.target.value != "91") {
        this.abroad_fields = true;
      } else {
        this.abroad_fields = false;
      }
      console.log(event.target.value);
    },
    filteredMembers() {
      this.loading_list = true;
      let filter_list = this.orgnal_member_lists;

      filter_list = filter_list.filter((samsung) => {
        return (
          this.search_qty
            .toLowerCase()
            .split(" ")
            .every((v) => samsung.name.toLowerCase().includes(v)) ||
          this.search_qty
            .toLowerCase()
            .split(" ")
            .every((v) => samsung.mobile.toLowerCase().includes(v))
        );
      });
      this.member_lists = filter_list;
      this.loading_list = false;
    },
    async loadUserDistrictAndPanchayaths() {
      this.selectedDistrict = this.currentUser.district_id;
      await this.fetchPanchayaths(this.selectedDistrict);
    },
    async fetchPanchayaths(districtId) {
      try {
        const response = await fetch(
          `https://guide.msoftit.com/api/location/panchayaths?district_id=${districtId}`
        );
        const data = await response.json();
        this.panchayaths = data.data.panchayaths;
      } catch (e) {
        this.panchayaths = [];
      }
    },
    async fetchWards(panchayathId) {
      try {
        const response = await fetch(
          `https://guide.msoftit.com/api/location/wards?panchayath_id=${panchayathId}`
        );
        const data = await response.json();
        this.wards = data.data.wards;
      } catch (e) {
        this.wards = [];
      }
    },
    async onPanchayathChange() {
      this.selectedWard = null;
      if (this.selectedPanchayath) {
        await this.fetchWards(this.selectedPanchayath);
      } else {
        this.wards = [];
      }
    },

    isAssociatedSelected(option) {
      return this.selectedAssociated.some(
        (selected) => selected.value === option.value
      );
    },

    toggleAssociatedSelection(option) {
      if (this.loading) return;

      const index = this.selectedAssociated.findIndex(
        (selected) => selected.value === option.value
      );

      if (index > -1) {
        this.selectedAssociated.splice(index, 1);
      } else {
        this.selectedAssociated.push(option);
      }
    },

    // Karad List specific methods
    moveToKaradList(member) {
      // Ensure karadForm is properly initialized
      if (!this.karadForm) {
        this.karadForm = {
          id: null,
          name: "",
          age: "",
          job: "",
          mobile_number: "",
          country_code: "91",
          whatsapp_number: "",
          country_code_whatsapp: "91",
          wing: "",
          selectedAssociated: [],
          selectedPanchayath: null,
          selectedWard: null,
        };
      }

      // Populate karadForm with member data
      this.karadForm.id = member.id;
      this.karadForm.name = member.name;
      this.karadForm.age = member.age;
      this.karadForm.mobile_number = member.mobile;
      this.karadForm.country_code = member.country_code;
      this.karadForm.wing = member.wing;

      // Handle job data
      if (member.job) {
        try {
          const jobArray = JSON.parse(member.job);
          this.karadForm.job = jobArray.length > 0 ? jobArray[0] : "";
        } catch (e) {
          this.karadForm.job = member.job;
        }
      } else {
        this.karadForm.job = "";
      }

      // Handle associated data
      if (member.associated) {
        try {
          const associatedArray = JSON.parse(member.associated);
          this.karadForm.selectedAssociated = this.associatedOptions.filter(
            (option) => associatedArray.includes(option.value)
          );
        } catch (e) {
          this.karadForm.selectedAssociated = this.associatedOptions.filter(
            (option) => option.value === member.associated
          );
        }
      } else {
        this.karadForm.selectedAssociated = [];
      }

      // Handle WhatsApp data
      this.karadForm.whatsapp_number = member.whatsapp || "";
      this.karadForm.country_code_whatsapp =
        member.whatsapp_country_code || "91";

      // Handle Panchayath and Ward data
      this.karadForm.selectedPanchayath = member.panchayath_id || null;
      if (this.karadForm.selectedPanchayath) {
        this.onKaradPanchayathChange();
      }
      this.karadForm.selectedWard = member.cluster_id || null;

      // Clear messages
      this.karadMessage = "";
      this.karadAssociatedSelectionError = "";

      $("#moveToKaradModel").modal("show");
    },

    isKaradAssociatedSelected(option) {
      return (
        this.karadForm &&
        this.karadForm.selectedAssociated &&
        this.karadForm.selectedAssociated.some(
          (selected) => selected.value === option.value
        )
      );
    },

    toggleKaradAssociatedSelection(option) {
      if (this.loading || !this.karadForm) return;

      const index = this.karadForm.selectedAssociated.findIndex(
        (selected) => selected.value === option.value
      );
      if (index > -1) {
        this.karadForm.selectedAssociated.splice(index, 1);
      } else {
        this.karadForm.selectedAssociated.push(option);
      }
      // Clear error when user makes selection
      this.karadAssociatedSelectionError = "";
    },

    async onKaradPanchayathChange() {
      if (!this.karadForm) return;

      if (this.karadForm.selectedPanchayath) {
        this.karadWards = [];
        this.karadForm.selectedWard = null;
        try {
          await this.fetchWards(this.karadForm.selectedPanchayath);
          this.karadWards = this.wards; // Use the same wards data
        } catch (error) {
          console.error("Error fetching wards:", error);
        }
      } else {
        this.karadWards = [];
        this.karadForm.selectedWard = null;
      }
    },

    moveToKaradSubmit() {
      // Ensure karadForm exists before validation
      if (!this.karadForm) {
        this.karadMessage = "Form data is not available. Please try again.";
        return;
      }

      // Validate required fields
      if (!this.karadForm.name) {
        this.karadMessage = "പേര് ടൈപ്പ് ചെയ്യുക!";
        return;
      }
      if (!this.karadForm.age) {
        this.karadMessage = "വയസ്സ് ടൈപ്പ് ചെയ്യുക!";
        return;
      }
      if (!this.karadForm.job) {
        this.karadMessage = "ജോലി തിരഞ്ഞെടുക്കുക!";
        return;
      }
      if (!this.karadForm.mobile_number) {
        this.karadMessage = "മൊബൈൽ നമ്പർ ടൈപ്പ് ചെയ്യുക!";
        return;
      }
      if (!this.karadForm.wing) {
        this.karadMessage = "വിങ് സെലക്ട് ചെയ്യുക!";
        return;
      }
      if (
        !this.karadForm.selectedAssociated ||
        this.karadForm.selectedAssociated.length === 0
      ) {
        this.karadAssociatedSelectionError =
          "കുറഞ്ഞത് ഒരു ബന്ധം തിരഞ്ഞെടുക്കുക!";
        return;
      }

      this.loading = true;
      this.karadMessage = "";

      const data = {
        id: this.karadForm.id,
        name: this.karadForm.name,
        age: this.karadForm.age,
        job: JSON.stringify([this.karadForm.job]),
        mobile_number: this.karadForm.mobile_number,
        country_code: this.karadForm.country_code,
        whatsapp_number: this.karadForm.whatsapp_number,
        country_code_whatsapp: this.karadForm.country_code_whatsapp,
        wing: this.karadForm.wing,
        associated: JSON.stringify(
          this.karadForm.selectedAssociated.map((option) => option.value)
        ),
        panchayath_id: this.karadForm.selectedPanchayath,
        cluster_id: this.karadForm.selectedWard,
        unit_id: this.unit_id ? this.unit_id : this.currentUser.unit_id,
        added_by: this.currentUser.id,
        from: "dawa_directory",
        type: "member", // Member type for Karad List (full members)
      };

      // Use the same API endpoint as DirectoryList.vue
      UserService.authPostRequest("members", data).then(
        (response) => {
          this.loading = false;
          if (response.data.status === "success") {
            this.$swal(
              "Success",
              "Member moved to Karad List successfully!",
              "success"
            );
            $("#moveToKaradModel").modal("hide");

            // Store the member ID before resetting the form
            const movedMemberId = this.karadForm.id;
            this.resetKaradForm();

            // Remove the moved member from current lists
            this.removeMemberFromLists(movedMemberId);
            this.getMembersList(this.wing);
          } else if (
            response.data.status === "error" ||
            response.data.status === "warning"
          ) {
            this.karadMessage = response.data.message || "An error occurred";
          } else {
            this.karadMessage = "An unexpected error occurred";
          }
        },
        (error) => {
          this.loading = false;
          this.karadMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },

    closeMoveToKaradModel() {
      $("#moveToKaradModel").modal("hide");
      this.resetKaradForm();
    },

    resetKaradForm() {
      this.karadForm = {
        id: null,
        name: "",
        age: "",
        job: "",
        mobile_number: "",
        country_code: "91",
        whatsapp_number: "",
        country_code_whatsapp: "91",
        wing: "",
        selectedAssociated: [],
        selectedPanchayath: null,
        selectedWard: null,
      };
      this.karadMessage = "";
      this.karadWards = [];
      this.karadAssociatedSelectionError = "";
    },

    removeMemberFromLists(memberId) {
      // Remove from temp_member_lists (current displayed list)
      this.temp_member_lists = this.temp_member_lists.filter(
        (member) => member.id !== memberId
      );

      // Remove from member_lists (main list)
      this.member_lists = this.member_lists.filter(
        (member) => member.id !== memberId
      );

      // Remove from orgnal_member_lists (original list for search)
      this.orgnal_member_lists = this.orgnal_member_lists.filter(
        (member) => member.id !== memberId
      );
    },
  },
};
</script>

<style scoped>
.section-heading {
  padding: 10px 10px 0px 10px;
}

.error-feedback {
  color: red;
}

.listview {
  margin-bottom: 20px;
}

.edit-btn {
  margin-left: 8px;
}

.progress {
  width: 80px;
}

.listview > li footer {
  color: #171617;
}

.min-width-50 {
  min-width: 60% !important;
}

.action-button-list > li {
  min-height: 1px !important;
}

.sl-no {
  font-weight: 900;
  margin-right: 12px;
}

.deleted-list-title {
  font-size: 15px;
}

.deleted-list {
  margin-bottom: 20px;
}

.deleted-info {
  background-color: #f2bbca;
  font-size: 12px;
}

.deleted-info strong {
  font-size: 18px;
  font-weight: 600;
}

.image-listview.text > li:after {
  left: 0px;
  /* height: 1px; */
  background-color: #1a418c;
}

.verification-badge {
  margin-left: 5px;
}

.avatar-section .button {
  color: #fff;
  width: 18px;
  height: 18px;
  border-radius: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  position: absolute;
  right: 10px;
  top: 24px;
  bottom: 0;
}

.avatar-section .verified {
  background: #4dc81c;
}

.avatar-section .not-verified {
  background: #eb3941;
}

.green-tick {
  font-size: 18px;
  color: darkgreen;
}

.red-cross {
  font-size: 18px;
  color: red;
}

.qhls-text {
  font-style: italic;
  color: #266bd1;
}

.stat-box {
  background: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.09);
  border-radius: 10px;
  padding: 10px 10px;
}

.tab-container-1 {
  display: flex;
  justify-content: center;
  margin: 1.5rem 0 1rem 0;
}

.pill-tabs {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  max-width: 600px;
  margin: 0 auto;
}

.pill-tab {
  flex: 1 1 140px;
  min-width: 120px;
  max-width: 200px;
  padding: 0.6rem 1rem;
  border: none;
  border-radius: 999px;
  background: #f5f7fa;
  color: #1a418c;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.18s, color 0.18s, box-shadow 0.18s;
  outline: none;
  box-shadow: 0 1px 3px rgba(26, 65, 140, 0.04);
  margin: 0;
  text-align: center;
  white-space: nowrap;
}

.pill-tab.active,
.pill-tab:focus {
  background: #1a418c;
  color: #fff;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(26, 65, 140, 0.1);
}

.multiselect-custom {
  min-height: 40px;
}

.multiselect-custom .multiselect__tags {
  min-height: 40px;
  padding: 8px 40px 0 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.multiselect-custom .multiselect__tag {
  background: #007bff;
  color: white;
  margin-bottom: 5px;
}

.multiselect-custom .multiselect__tag-icon:after {
  color: white;
}

.multiselect-custom .multiselect__tag-icon:focus,
.multiselect-custom .multiselect__tag-icon:hover {
  background: #0056b3;
}

.multiselect-custom .multiselect__option--highlight {
  background: #007bff;
  color: white;
}

.multiselect-custom .multiselect__option--selected {
  background: #f8f9fa;
  color: #495057;
  font-weight: bold;
}

@media (max-width: 800px) {
  .pill-tabs {
    max-width: 100%;
    gap: 0.7rem;
  }

  .pill-tab {
    flex: 1 1 110px;
    font-size: 0.98rem;
    padding: 0.5rem 0.7rem;
  }
}

@media (max-width: 500px) {
  .pill-tabs {
    gap: 0.5rem;
  }

  .pill-tab {
    flex: 1 1 90px;
    font-size: 0.95rem;
    padding: 0.45rem 0.5rem;
  }
}

.associated-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
  max-height: 300px;
  overflow-y: auto;
  padding: 0.5rem;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  background-color: #fff;
}

.associated-item {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  margin: 7px 0px;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  background-color: #fafafa;
  transition: all 0.2s ease;
  cursor: pointer;
}

.associated-item:hover {
  background-color: #e3f2fd;
  border-color: #90caf9;
}

.associated-item.selected {
  background-color: #e8f5e8;
  border-color: #357737;
}

.associated-checkbox {
  margin-right: 0.5rem;
  flex-shrink: 0;
}

.associated-name {
  font-size: 0.9rem;
  line-height: 1.2;
  color: #333;
  word-break: break-word;
}

.selected-count {
  margin-top: 0.5rem;
  text-align: center;
  padding: 0.25rem;
  background-color: #e3f2fd;
  border-radius: 4px;
}

.text-muted {
  color: #6c757d;
}

.text-danger {
  color: #dc3545;
}

.small {
  font-size: 0.875rem;
}

/* Mobile specific adjustments */
@media (max-width: 576px) {
  .associated-grid {
    grid-template-columns: 1fr;
    gap: 0.25rem;
  }

  .associated-item {
    padding: 0.75rem 0.5rem;
  }

  .associated-name {
    font-size: 0.95rem;
  }
}

/* Very small screens */
@media (max-width: 400px) {
  .associated-item {
    padding: 0.5rem 0.25rem;
  }

  .associated-name {
    font-size: 0.85rem;
  }
}

/* Custom scrollbar for better mobile experience */
.associated-grid::-webkit-scrollbar {
  width: 4px;
}

.associated-grid::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.associated-grid::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.associated-grid::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
